const SIGNATURE_IDS = ['Signature', 'ms-outlook-mobile-signature'];

export default function extractSignature(html: string): string | undefined {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const signature = SIGNATURE_IDS.map((id) => doc.getElementById(id)).find(
    (el): el is HTMLElement => Boolean(el),
  );
  if (!signature) return undefined;

  signature.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
  signature
    .querySelectorAll('div, p, li, tr')
    .forEach((block) => block.append('\n'));
  signature.querySelectorAll('td').forEach((cell) => cell.append(' '));

  const lines = signature.textContent
    ?.split('\n')
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  return lines?.length ? lines.join('\n') : undefined;
}
